// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Lato:wght@100;300;400;700;900);"]);
// Module
exports.push([module.id, ".v-data-footer[data-v-577c341e]{justify-content:center}.data-table__pre-header[data-v-577c341e]{border-bottom:1px solid var(--pale-sky-blue)}.orange--text[data-v-577c341e]{color:var(--orange)!important}.dialog-attention[data-v-577c341e]{border:2px solid var(--orange)}.dropdown-element-style[data-v-577c341e]{color:#2b2b2b;font-family:Lato,sans-serif;font-size:13px;width:100%}", ""]);
// Exports
module.exports = exports;
